import React, { FC } from 'react';

export const IcSubscribe: FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4879_16565)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.4 19.4C21.2 15.8 18.6 13.7 15.1 13.7C11.7 13.7 8.99997 15.8 7.79997 19.4C7.69997 19.6 7.79997 19.9 7.89997 20C7.99997 20.2 8.19997 20.3 8.49997 20.3H21.7C21.9 20.3 22.1 20.2 22.3 20C22.4 19.9 22.4 19.7 22.4 19.4ZM20.2 19H9.89997C9.69997 19 9.59997 18.8 9.69997 18.6C10.8 16.4 12.7 15.2 15.1 15.2C17.4 15.2 19.3 16.4 20.5 18.6C20.6 18.8 20.4 19 20.2 19Z"
          fill="#666666"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.8 8.70001C6.1 8.70001 6.4 9.00001 6.5 9.30001V9.40001V10.7C6.5 10.9 6.7 11.1 6.9 11.1H8.2C8.6 11.1 9 11.4 9 11.9C9 12.3 8.7 12.6 8.4 12.6H8.3H6.9C6.7 12.6 6.5 12.8 6.5 13V14.4C6.5 14.8 6.2 15.2 5.7 15.2C5.3 15.2 5 14.9 5 14.6V14.5V13C5 12.8 4.8 12.6 4.6 12.6H3.3C2.8 12.6 2.5 12.3 2.5 11.9C2.5 11.5 2.8 11.2 3.1 11.2H3.2H4.6C4.8 11.2 5 11 5 10.8V9.40001C5 9.00001 5.3 8.70001 5.8 8.70001Z"
          fill="#666666"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.1 3C12.4 3 10.3 5.2 10.3 7.8C10.3 10.5 12.5 12.6 15.1 12.6C17.8 12.6 19.9 10.4 19.9 7.8C19.9 5.2 17.8 3 15.1 3ZM15.1 11.3C13.2 11.3 11.7 9.8 11.7 7.9C11.7 6 13.2 4.5 15.1 4.5C17 4.4 18.5 6 18.5 7.8C18.5 9.7 17 11.3 15.1 11.3Z"
          fill="#666666"
        />
      </g>
      <defs>
        <clipPath id="clip0_4879_16565">
          <rect
            width="19.9"
            height="17.4"
            fill="white"
            transform="translate(2.5 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
